module.exports = __webpack_public_path__ + "img/noRecord.60c4cfc5.png";